__turbopack_context__.v({
  "actionsRow": "PrecisionTest-module__KRBCIq__actionsRow",
  "body": "PrecisionTest-module__KRBCIq__body",
  "clicksLabel": "PrecisionTest-module__KRBCIq__clicksLabel",
  "feedback": "PrecisionTest-module__KRBCIq__feedback",
  "info": "PrecisionTest-module__KRBCIq__info",
  "isActive": "PrecisionTest-module__KRBCIq__isActive",
  "isFilled": "PrecisionTest-module__KRBCIq__isFilled",
  "isSuccess": "PrecisionTest-module__KRBCIq__isSuccess",
  "isSuccessDot": "PrecisionTest-module__KRBCIq__isSuccessDot",
  "precision-pulse": "PrecisionTest-module__KRBCIq__precision-pulse",
  "progressDot": "PrecisionTest-module__KRBCIq__progressDot",
  "progressDots": "PrecisionTest-module__KRBCIq__progressDots",
  "result-failed": "PrecisionTest-module__KRBCIq__result-failed",
  "result-success": "PrecisionTest-module__KRBCIq__result-success",
  "runner": "PrecisionTest-module__KRBCIq__runner",
  "runnerDanger": "PrecisionTest-module__KRBCIq__runnerDanger",
  "runnerSuccess": "PrecisionTest-module__KRBCIq__runnerSuccess",
  "shell": "PrecisionTest-module__KRBCIq__shell",
  "status-failed": "PrecisionTest-module__KRBCIq__status-failed",
  "status-initial": "PrecisionTest-module__KRBCIq__status-initial",
  "status-success": "PrecisionTest-module__KRBCIq__status-success",
  "statusPill": "PrecisionTest-module__KRBCIq__statusPill",
  "targetRing": "PrecisionTest-module__KRBCIq__targetRing",
  "wrapper": "PrecisionTest-module__KRBCIq__wrapper",
});
